import { Box, Typography, Container, Button, Card, CardContent } from '@mui/material';
import { useState } from 'react';
import { InsertPaperModal } from 'src/modal/vendor/InsertPaperModal';
import AppManager from '../../commun/AppManager';
import { EuroSpan } from '../../commun/component/EuroSpan';
import { PourcentSpan } from '../../commun/component/PourcentSpan';
import { AddIcon } from '../../icons/AddIcon';
import { BinIcon } from '../../icons/BinIcon';
import { EditIcon } from '../../icons/EditIcon';
import { StatistiqueIcon } from '../../icons/StatistiqueIcon';
import BasePrice from '../../object/BasePrice';
import Budget from '../../object/Budget';
import { Paper } from '../../object/Paper';
import { BudgetFillTable } from '../budget/BudgetFillTable';
import { BudgetTable } from '../budget/BudgetTable';
import { PaperFillTable } from '../budget/PaperFillTable';
import PaperModal from '../budget/PaperModal';
import { PaperStatView } from '../budget/PaperStatView';

export const DevisOptionView = (props: { basePrice: BasePrice }) => {
    const { basePrice } = props;

    basePrice.fetchOption();

    const [openAdd, setOpenAdd] = useState(false);
    const [openInsert, setOpenInsert] = useState(false);

    const paper = basePrice.getSelectedPaper() ?? new Paper();

    return (
        <Container maxWidth={false}>
            <Box sx={{ mb: 3, mt: 3 }}>
                <Box
                    sx={{
                        alignItems: 'center',
                        display: 'flex',
                        gap: 3,
                        flexWrap: 'wrap',
                        m: -1,
                    }}
                >
                    <Typography sx={{ m: 1 }} variant="h4">
                        {'Option de votre prix de vente'}
                    </Typography>
                </Box>
            </Box>
            <Box className="shadow-xl">
                <BudgetFillTable
                    basePrice={basePrice}
                    paper={paper}
                    list={basePrice.getBudgetInOptionList() ?? []}
                    loading={!paper.load}
                    option={true}
                    color="white"
                />
            </Box>
            <Box sx={{ mb: '50vh' }}></Box>
        </Container>
    );
};
